import { FilterTypes } from '../../../../interfaces/src/lib/enums/index';
import { setSelectedPortsExcursions } from '../stateManager/slices/facetFilterSlice';
import { AppDispatch, store } from '../stateManager/store';
import { getAttributeValue, isTemplateClassPresent } from './utilFuncs';

/**
 * Processes and dispatches various filters for deals.
 *
 * @param {AppDispatch} dispatch - The dispatch function from the Redux store.
 *
 * This function retrieves the deals filters from the Redux store and applies them
 * by dispatching appropriate settings. It handles various filter types such as ship,
 * port, number of nights, cabin, cruise ID, price type, price code, port of call,
 * destination, fly and cruise, start date, end date, min price, max price, and guest filters.
 *
 * The function also collects complex filter data (dates, prices, and guest data) and
 * dispatches them after the loop.
 */
export function useDynamicFilters(dispatch: AppDispatch) {
  // Get the raw filters from the deals context
  const isDynamicPage = isTemplateClassPresent('dynamicpage');
  const portCode = getAttributeValue('portCode');
  if (!isDynamicPage || !portCode) return;
  const state = store.getState();
  const selectedPorts = state.facetFilter.selectedPortsExcursions;
  // Create a set of valid filterType values from the FilterTypes enum
  if (selectedPorts.length === 0)
    dispatch(setSelectedPortsExcursions(parseValues(FilterTypes.PORT_EXCURSIONS, portCode)));
}

const parseValues = (_name: string | null | undefined, paramValue: string | null | undefined) => {
  if (!paramValue) return [];
  return paramValue.split(',').map((item) => ({ name: '', value: item.trim() }));
};

export function isTherePortChips(): boolean {
  const isDynamicPage = isTemplateClassPresent('dynamicpage');
  const portCode = getAttributeValue('portCode');
  return !(!isDynamicPage || !portCode);
}

// Function to check if a filter type is included in deals filters
export function checkDynamicFilterType(filterType: string): boolean {
  const isDynamicPage = isTemplateClassPresent('dynamicpage');
  const portCode = getAttributeValue('portCode');
  return (
    isDynamicPage && typeof portCode === 'string' && filterType === FilterTypes.PORT_EXCURSIONS
  );
}

export function appendDynamicPort(): void {
  const isDynamicPage = isTemplateClassPresent('dynamicpage');
  if (!isDynamicPage) return;
  const portCode = getAttributeValue('portCode');
  if (!portCode) return;
  const element = document.getElementById('find-a-cruise-button-port-dy') as HTMLAnchorElement;
  // Find the link <a> in the div e update the href
  if (element?.href) {
    const linkUrl = new URL(element?.href, window.location.origin);
    linkUrl.searchParams.set('portOfCall', portCode);
    if (element) {
      element.href = linkUrl.toString();
    }
  }
}
